import { useEffect, useState } from 'react';
import cfg from 'envConfig';
import type { Banner } from '@@/api/api-outage-notifications';
import { OutageNotificationsClient } from '@@/api/api-outage-notifications';

export function useLoginBannerAndAvailability() {
  const [banner, setBanner] = useState<Banner | null>(null);
  const [hideLogin, setHideLogin] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const fallback = (cfg as Record<string, unknown>).outageNotificationsFallbackApi as string;
        const client = new OutageNotificationsClient();
        const { banner: b, hideLogin: h } = await client.fetchActiveBannerFromRegions(fallback, 'login');
        if (!cancelled) {
          setBanner(b);
          setHideLogin(h);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { banner, hideLogin, loading } as const;
}
